var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":_vm.$t('modals.company.billing.editTitle'),"action":"update","on-submit":_vm.submit,"on-close":() => _vm.$emit('close')}},[_c('billing-form',{attrs:{"company":_vm.company}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }